'use client';

import Link from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthButtons } from '../AuthButtons';
import { HeaderSkeleton } from '../HeaderSkeleton';
import { Logo } from '../Logo';
import { DepositPanel } from '../UserBlock';
import { AnalyticsEventName } from '@/api/analytics';
import { useAnalytics } from '@/hooks/analytics';
import { useFixedHeader } from '@/hooks/header';
import { useNavigation } from '@/hooks/navigation';
import { usePopupHeight } from '@/hooks/usePopupHeight';
import { useCommonStore } from '@/store';

import { ScHeaderLogo, ScHeaderMobile, ScHeaderRowMob } from '../styled';
import { ScContainer } from '@/styles/common';

export const HeaderMobile: FC = () => {
  const {
    i18n: { language },
  } = useTranslation('common');
  const isFixedHeader = useFixedHeader(language);

  const { sendEventToAnalytics } = useAnalytics();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUserPure = useCommonStore.use.pendingUserPure();

  const { generateLink } = useNavigation();

  const handleLUHomeClick = () => {
    sendEventToAnalytics({ name: AnalyticsEventName.LU_HOME_TOP });
  };

  const { popupHeight } = usePopupHeight();

  return (
    <ScHeaderMobile
      withBg
      isFixedHeader={isFixedHeader}
      wide={isAuthenticated}
      popupHeight={popupHeight}
    >
      <ScContainer>
        {pendingUserPure ? (
          <HeaderSkeleton />
        ) : (
          <ScHeaderRowMob>
            <ScHeaderLogo>
              <Link href={generateLink('/')} onClick={handleLUHomeClick}>
                <Logo />
              </Link>
            </ScHeaderLogo>
            {isAuthenticated ? (
              <DepositPanel noPadding blackBg />
            ) : (
              <div className={`reg-btns ${language.toLowerCase()}`}>
                <AuthButtons />
              </div>
            )}
          </ScHeaderRowMob>
        )}
      </ScContainer>
    </ScHeaderMobile>
  );
};
